import React, { useState, useEffect } from "react";
import CS from "../../../services/commonService";
import { Link } from "react-router-dom";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";
import Table from "../../common/table";
import { useStore } from "../../../zustand/store";
import qs from "qs";
import { URL } from "../../../constants/URL";
import { modules } from "../../../constants/Modules";
import RenderUser from "../../common/User";
import {
	useApprovePromoGiftsRequest,
	useGetPromoGiftsApprovalRequests,
} from "../../../queryHooks";

//	Pre-defined values
const columnKey = "promoApprovalRequests";
//	Component starts
const ApprovalRequests = () => {
	const { lastPageData, setLastPageData, setLoading } = useStore(
		(state) => state
	);

	const [tableData, setTableData] = useState([]);
	const [itemsPerPage, setItemsPerPage] = useState(
		lastPageData?.[modules.PROMO_APPROVAL_REQUESTS]?.items_per_page || 10
	);
	const [pageNow, setPageNow] = useState(
		lastPageData?.[modules.PROMO_APPROVAL_REQUESTS]?.page || 1
	);
	const [giftsPayload, setGiftspayload] = useState(
		lastPageData?.[modules.PROMO_APPROVAL_REQUESTS] || {
			pagination: true,
			items_per_page: itemsPerPage,
			page: pageNow,
			sort: { created_at: "DESC" },
		}
	);

	const {
		data: dataGetGifts,
		refetch,
		isLoading,
	} = useGetPromoGiftsApprovalRequests();

	useEffect(() => {
		if (dataGetGifts && dataGetGifts.status === "success") {
			let respData = dataGetGifts?.data;
			respData.total_items = dataGetGifts?.data?.records?.length;
			respData.items_per_page = dataGetGifts?.data?.records?.length;
			setItemsPerPage(respData.total_items);
			setTableData(respData);
		}
	}, [dataGetGifts]);

	const {
		mutateAsync: approvePromoGiftAsync,
		data: dataApprovePromoGift,
		error: errorApprovePromoGift,
		isLoading: isLoadingApprovePromoGift,
	} = useApprovePromoGiftsRequest();

	useEffect(() => {
		if (errorApprovePromoGift) {
			CS.showErrorMessage(
				errorApprovePromoGift?.response?.data?.message ||
					errorApprovePromoGift?.data?.message
			);
		}
	}, [errorApprovePromoGift]);

	useEffect(() => {
		if (dataApprovePromoGift) {
			if (dataApprovePromoGift?.status === "success") {
				CS.showSuccessMessage(dataApprovePromoGift?.message);
				refetch();
			} else if (dataApprovePromoGift?.status === "fail") {
				CS.showErrorMessage(dataApprovePromoGift?.message);
			}
		}
	}, [dataApprovePromoGift]);

	useEffect(() => {
		setLoading(isLoadingApprovePromoGift);
	}, [isLoadingApprovePromoGift]);

	const columns = [
		{
			label: "Created Date",
			type: "date",
			// sort: true,
			path: "created_at",
			// filterDate: true,
			alias: "created_at",
			content: (item) => (
				<span>
					{item?.created_at ? getCurrentTimezoneDate(item.created_at) : null}
				</span>
			),
		},
		{
			label: "Restaurant",
			type: "string",
			path: "data_restaurants.name",
			alias: "data_restaurants.name",
			content: (item) => (
				<Link
					to={{
						pathname: `${URL.restaurants}/${item.restaurant_id}`,
						state: { key: "giftOrders" },
					}}
					onClick={() => {
						setLastPageData({
							[modules.PROMO_APPROVAL_REQUESTS]: giftsPayload,
						});
					}}
				>
					<RenderUser
						profileImageUrl={item?.restaurant?.profile_image_url}
						firstName={item?.restaurant?.name}
					/>
				</Link>
			),
		},
		{
			label: "Total Recipients",
			type: "string",
			path: "users_count",
			alias: "users_count",
			content: (item) => (
				<div className="ml-3">
					<p>{item?.users_count}</p>
				</div>
			),
		},

		{
			label: "Action",
			type: "boolean",
			content: (item) => (
				<div className="d-flex justify-content-between">
					<button
						className="btn btn-primary glow-primary mr-4"
						onClick={() => {
							approvePromoGiftAsync({
								restaurant_id: item?.restaurant?.id,
								request_id: item?.id,
								is_approved: true,
							});
						}}
					>
						Approve
					</button>
					<button
						className="btn btn-outline-primary"
						onClick={() => {
							approvePromoGiftAsync({
								restaurant_id: item?.restaurant?.id,
								request_id: item?.id,
								is_approved: false,
							});
						}}
					>
						Reject
					</button>
				</div>
			),
		},
	];

	return (
		<React.Fragment>
			<div className="dataTables_wrapper">
				<div className="content-area position-relative">
					<div className="grid">
						<div className="grid-content">
							<Table
								columnKey={columnKey}
								columns={columns}
								tableData={tableData}
								payload={giftsPayload}
								sortCol={(obj) => {
									setPageNow(1);
									setGiftspayload({
										...giftsPayload,
										sort: {
											[obj.alias]:
												!obj.sort && obj.sort === "" ? undefined : obj.sort,
										},
										page: 1,
									});
								}}
								setCurrentPage={(page) => {
									setPageNow(page);
									setGiftspayload({
										...giftsPayload,
										page,
									});
								}}
								setCurrentLimit={(items_per_page) => {
									setPageNow(1);
									setItemsPerPage(items_per_page);
									setGiftspayload({
										...giftsPayload,
										items_per_page,
										page: 1,
									});
								}}
								loading={isLoading}
								filterValue={async (obj) => {
									if (obj.filter === null) {
										const resp = await CS.filterData(giftsPayload.filter, obj);
										setPageNow(1);
										setGiftspayload({
											...giftsPayload,
											filter: resp,
											page: 1,
										});
									} else {
										setPageNow(1);
										setGiftspayload({
											...giftsPayload,
											filter: {
												...giftsPayload.filter,
												[obj.alias]: obj.filter,
											},
											page: 1,
										});
									}
								}}
								filterDate={(dates) => {
									setPageNow(1);
									setGiftspayload({
										...giftsPayload,
										filter_date: dates && {
											...giftsPayload?.filter_date,
											[dates.alias]: String(dates.filter),
										},
										page: 1,
									});
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default ApprovalRequests;
